<template>
  <div>
    <div class="form-group">
      <label :for="`${goalUuid}-obj-${level}-title`">{{ level }} Quarter Title | {{ accessPointToLabelMap[apLevel] }} </label>
      <input
        type="text"
        :id="`${goalUuid}-obj-${level}-title`"
        v-model="titleInternal"
        @input="$emit('update:title', titleInternal)"
        class="form-control"
        placeholder="Objective title">
    </div>
    <div class="form-group">
      <label :for="`${goalUuid}-obj-${level}-text`">{{ level }} Quarter Text | {{ accessPointToLabelMap[apLevel] }} </label>
      <textarea
        v-model="textInternal"
        :id="`${goalUuid}-obj-${level}-text`"
        class="form-control"
        @input="$emit('update:text', textInternal)"
        placeholder="Objective text"/>
    </div>
    <slot />
  </div>
</template>

<script>
import { isValidObjectiveLevel } from '@/components/goals/common/objectives'
import { AccessPointsUtil } from '@/components/goals/common/access_points'

export default {
  name: 'EditObjective',
  props: {
    goalUuid: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    // note: this "level" is not the same thing as an access point level. Objectives have their own "level" (e.g. 1st, 2nd, 3rd representing which quarterly objective)
    level: {
      type: String,
      required: true,
      validator: isValidObjectiveLevel
    },
    text: {
      type: String,
      required: true
    },
    apLevel: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      titleInternal: this.title || '',
      textInternal: this.text || '',
      accessPointToLabelMap: AccessPointsUtil.labelsMap,
    }
  },
  watch: {
    text(newValue) {
      this.textInternal = newValue
    },
    title(newValue) {
      this.titleInternal = newValue
    }
  }
}
</script>

<style lang="less" scoped>
</style>
